export const normalizePrivacyValue = (value?: string | null): string => {
  if (!value) return "";
  return String(value)
    .toLowerCase()
    .replace(/[^a-z]/g, "");
};

const BLUR_KEYWORDS = [
  "none",
  "donotpublish",
  "dontpublish",
  "notpublish",
  "accepted",
  "acceptmembers",
  "acceptedmembers",
  "acceptedOnly",
  "onlyacceptedmembers",
  "membersonly",
  "memberonly",
  "blur",
  "private",
];

export const shouldBlurProfileImage = (privacy?: string | null): boolean => {
  const normalized = normalizePrivacyValue(privacy);
  if (!normalized) return false;
  return BLUR_KEYWORDS.some((keyword) => normalized.includes(keyword));
};

const DISPLAY_LABELS: Record<string, string> = {
  all: "Publish to All Members",
  public: "Publish to All Members",
  everyone: "Publish to All Members",
  visible: "Publish to All Members",
  publishallmembers: "Publish to All Members",
  accepted: "Only Accepted Members",
  acceptedonly: "Only Accepted Members",
  acceptmembers: "Only Accepted Members",
  acceptedmembers: "Only Accepted Members",
  membersonly: "Only Accepted Members",
  memberonly: "Only Accepted Members",
  connectedmembers: "Only Accepted Members",
  choice: "Only Accepted Members",
  blur: "Blurred Preview",
  blurred: "Blurred Preview",
  none: "Do Not Publish",
  donotpublish: "Do Not Publish",
  dontpublish: "Do Not Publish",
  notpublish: "Do Not Publish",
  private: "Do Not Publish",
  hidden: "Do Not Publish",
};

export const getImagePrivacyDisplayLabel = (
  privacy?: string | null,
): string | null => {
  const normalized = normalizePrivacyValue(privacy);
  if (!normalized) return null;
  const direct = DISPLAY_LABELS[normalized];
  if (direct) return direct;
  if (normalized.includes("accept")) {
    return DISPLAY_LABELS.accepted;
  }
  if (normalized.includes("member")) {
    return DISPLAY_LABELS.membersonly;
  }
  if (
    normalized.includes("donotpublish") ||
    normalized.includes("dontpublish") ||
    normalized.includes("notpublish")
  ) {
    return DISPLAY_LABELS.donotpublish;
  }
  if (normalized.includes("blur")) {
    return DISPLAY_LABELS.blur;
  }
  return null;
};

export const getPrivacyOverlayLabel = (
  privacy?: string | null,
): string | null => {
  if (!shouldBlurProfileImage(privacy)) return null;
  const normalized = normalizePrivacyValue(privacy);

  if (normalized.includes("accept")) {
    return "Accepted Members Only";
  }
  if (
    normalized.includes("donotpublish") ||
    normalized.includes("dontpublish") ||
    normalized.includes("notpublish") ||
    normalized.includes("none")
  ) {
    return "Photo Not Published";
  }
  if (normalized.includes("member")) {
    return "Members Only";
  }
  if (normalized.includes("blur")) {
    return "Blurred Photo";
  }
  return "Private Photo";
};
